import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-carbonscore',
    templateUrl: './carbonscore.component.html',
    styleUrls: ['./carbonscore.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarbonscoreComponent {

  @Input() score: string;
  @Input() culture: string;

  constructor() {}

}
